import Backbone from 'backbone';
import Form from './FormValidator';
import $ from 'jquery';

export default Backbone.View.extend({
  selectors: {
    form: '.js-resetpassword-form',
    oldPasswordInput: '.js-old_password_input',
    oldPasswordInputEyeOn: '.js-old_password_input_eye_on',
    oldPasswordInputEyeOff: '.js-old_password_input_eye_off',
    newPasswordInput: '.js-new_password_input',
    newPasswordInputEyeOn: '.js-new_password_input_eye_on',
    newPasswordInputEyeOff: '.js-new_password_input_eye_off',
    confirmNewPasswordInput: '.js-confirm_new_password_input',
    confirmNewPasswordInputEyeOn: '.js-confirm_new_password_input_eye_on',
    confirmNewPasswordInputEyeOff: '.js-confirm_new_password_input_eye_off',
  },

  events: {
    'click .js-old_password_input_eye_on': 'showOldPasswordValue',
    'click .js-old_password_input_eye_off': 'hideOldPasswordValue',
    'click .js-new_password_input_eye_on': 'showNewPasswordValue',
    'click .js-new_password_input_eye_off': 'hideNewPasswordValue',
    'click .js-confirm_new_password_input_eye_on': 'showConfirmNewPasswordValue',
    'click .js-confirm_new_password_input_eye_off': 'hideConfirmNewPasswordValue',
  },

  showOldPasswordValue: function (e) {
    e.preventDefault();
    this.hidePasswordValue(
      this.selectors.newPasswordInputEyeOn,
      this.selectors.newPasswordInputEyeOff,
      this.selectors.newPasswordInput
    );
    this.hidePasswordValue(
      this.selectors.confirmNewPasswordInputEyeOn,
      this.selectors.confirmNewPasswordInputEyeOff,
      this.selectors.confirmNewPasswordInput
    );
    this.showPasswordValue(
      this.selectors.oldPasswordInputEyeOn,
      this.selectors.oldPasswordInputEyeOff,
      this.selectors.oldPasswordInput
    );
  },

  hideOldPasswordValue: function (e) {
    e.preventDefault();
    this.hidePasswordValue(
      this.selectors.oldPasswordInputEyeOn,
      this.selectors.oldPasswordInputEyeOff,
      this.selectors.oldPasswordInput
    );
  },

  showNewPasswordValue: function (e) {
    e.preventDefault();
    this.hidePasswordValue(
      this.selectors.confirmNewPasswordInputEyeOn,
      this.selectors.confirmNewPasswordInputEyeOff,
      this.selectors.confirmNewPasswordInput
    );
    this.hidePasswordValue(
      this.selectors.oldPasswordInputEyeOn,
      this.selectors.oldPasswordInputEyeOff,
      this.selectors.oldPasswordInput
    );
    this.showPasswordValue(
      this.selectors.newPasswordInputEyeOn,
      this.selectors.newPasswordInputEyeOff,
      this.selectors.newPasswordInput
    );
  },

  hideNewPasswordValue: function (e) {
    e.preventDefault();
    this.hidePasswordValue(
      this.selectors.newPasswordInputEyeOn,
      this.selectors.newPasswordInputEyeOff,
      this.selectors.newPasswordInput
    );
  },

  showConfirmNewPasswordValue: function (e) {
    e.preventDefault();
    this.hidePasswordValue(
      this.selectors.oldPasswordInputEyeOn,
      this.selectors.oldPasswordInputEyeOff,
      this.selectors.oldPasswordInput
    );
    this.hidePasswordValue(
      this.selectors.newPasswordInputEyeOn,
      this.selectors.newPasswordInputEyeOff,
      this.selectors.newPasswordInput
    );
    this.showPasswordValue(
      this.selectors.confirmNewPasswordInputEyeOn,
      this.selectors.confirmNewPasswordInputEyeOff,
      this.selectors.confirmNewPasswordInput
    );
  },

  hideConfirmNewPasswordValue: function (e) {
    e.preventDefault();
    this.hidePasswordValue(
      this.selectors.confirmNewPasswordInputEyeOn,
      this.selectors.confirmNewPasswordInputEyeOff,
      this.selectors.confirmNewPasswordInput
    );
  },

  showPasswordValue: function (eyeOnElement, eyeOffElement, inputElement) {
    $(eyeOnElement).hide();
    $(eyeOffElement).show();
    $(inputElement).attr('type', 'text');
    $(inputElement).focus();
  },

  hidePasswordValue: function (eyeOnElement, eyeOffElement, inputElement) {
    $(eyeOnElement).show();
    $(eyeOffElement).hide();
    $(inputElement).attr('type', 'password');
  },

  initialize: function () {
    this.validator = new Form({ target: this.selectors.form });
  },
});
